/* eslint lodash/prefer-includes:0,no-extra-parens:0,prefer-template:0,func-style:0 */

export default function runEditor(window, packagesStructure, requirejs, editorModel, queryUtil, config) {
  const packagesArr = ['symbols', 'addPanelData', 'rEditor', 'compPanels', 'core', 'wixStore', 'tpa',
    'util', 'blog', 'wixBookings', 'jquery', 'react', 'reactDOM', 'lodash', 'aviary', 'superAppMenuInfra', 'savePublish', 'panels',
    'addPanelInfra', 'experiment', 'staticAssets', 'pLoader', 'textControls', 'mediaFrame', 'keyboardMaster',
    'baseUI', 'uiAnimations', 'panelUtils', 'mediaServices', 'color', 'pms', 'databaseEditor', 'json',
    'gfppData', 'backgroundPresets', 'styles', 'pagesMenu', 'userPreferences', 'popups',
    'pLoader!santa:skins', 'pLoader!santa:documentServices', 'addPanelSections', 'addPanelDataConsts', 'addPanelSectionsEN']

  if (queryUtil.isParameterTrue('isqa')) {
    packagesArr.push('pLoader!santa:qaAutomation', 'debugTools')
  }
  if (queryUtil.isParameterTrue('isTpaIntegration')) {
    packagesArr.push('tpaIntegrationEditor', 'jasmine', 'jasmine-html', 'bluebird')
  }
  if (queryUtil.isParameterTrue('isUiLibIntegration')) {
    packagesArr.push('uiLibIntegrationEditor', 'jasmine', 'jasmine-html', 'bluebird')
  }
  if (queryUtil.isParameterTrue('isPlatformIntegration')) {
    packagesArr.push('platform', 'platformIntegrationEditor', 'jasmine', 'jasmine-html', 'bluebird')
  }

  const languageCode = window.editorModel && window.editorModel.languageCode
  const languagePackageName = languageCode && ('addPanelSections' + languageCode.toUpperCase())
  const existsInPackagesStructure = packagesStructure.indexOf(languagePackageName) !== -1
  const isSupportedAddPanelLanguage = !!config.paths[languagePackageName]
  if (!existsInPackagesStructure && isSupportedAddPanelLanguage) {
    packagesArr.push(languagePackageName)
  }

  const prefetch = window.isPrefetchMode ||
    window.location.pathname.indexOf('prefetch') > 0 ||
    queryUtil.isParameterTrue('prefetch')

      // Preload scripts for caching
  let onError = errorHandler
  if (prefetch && window.define) {
    onError = function () {}
    const plugins = {
      pLoader: true,
      json: true,
      text: true,
      experiment: true
    }
    const dummy = () => ({})
    const define = window.define
    window.define = function (name) {
      const args = Array.apply(null, arguments)
      if (!plugins.hasOwnProperty(name) && name !== 'jquery') {
        for (let i = 1; i < args.length; ++i) {
          if (typeof args[i] === 'function') {
            args[i] = dummy
          }
        }
      }
      return define.apply(this, args)
    }
    window.define.amd = define.amd
  }

  requirejs(packagesArr, function () {
    if (prefetch) {
      window.bi.event(589) // prefetch finished
      return
    }

    function buildFunctionParametersObject(_pkgs, args) {
      return _pkgs.reduce((result, pkg, index) => {
        result[pkg.replace(/^.*:/, '')] = args[index]
        return result
      }, {})
    }
    const p = buildFunctionParametersObject(packagesArr, arguments)

    if (languagePackageName) {
      p.addPanelSections.applyTranslatedSections(p[languagePackageName])
    }

    p.rEditor.editorMain.start(p)
  }, onError)

  function errorHandler(err) {
    if (!config.urlArgs) {
      if (err.requireModules) {
        err.requireModules.forEach(module => {
          requirejs.undef(module)
        })
      }
      config.urlArgs = 'c=' + Date.now()
      requirejs.config(config)
      requirejs(packagesArr, () => {
        err.errn = 'REQUIREJS_RETRY_ERROR'
        err.errc = 111025
        err.severity = 10
        requirejs.onError(err)
      }, error => {
        requirejs.onError(error)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./~/santa-main-r/src/main/lib/editor/runEditor.js